import { render, staticRenderFns } from "./TablePoint.vue?vue&type=template&id=642ab6f4"
import script from "./TablePoint.vue?vue&type=script&lang=js"
export * from "./TablePoint.vue?vue&type=script&lang=js"
import style0 from "./TablePoint.vue?vue&type=style&index=0&id=642ab6f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports